var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.33333C5.76582 2.33333 2.33333 5.76582 2.33333 10C2.33333 14.2342 5.76582 17.6667 10 17.6667C14.2342 17.6667 17.6667 14.2342 17.6667 10C17.6667 5.76582 14.2342 2.33333 10 2.33333ZM1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96665 6.6438C8.1911 6.51324 8.46804 6.51189 8.69375 6.64025L13.4854 9.36525C13.7133 9.49487 13.8541 9.73688 13.8541 9.99909C13.8541 10.2613 13.7133 10.5033 13.4854 10.6329L8.69375 13.3579C8.46804 13.4863 8.1911 13.4849 7.96665 13.3544C7.74221 13.2238 7.60413 12.9837 7.60413 12.7241V7.27409C7.60413 7.01443 7.74221 6.77436 7.96665 6.6438ZM9.06246 8.52759V11.4706L11.6499 9.99909L9.06246 8.52759Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.eafdecc4e60136b207588b6732d2f97a.svg";
export { ForwardRef as ReactComponent };